import { Link } from "react-router-dom";
import { getCategoryName, formatViews, type NewsItem } from "@/lib/content";

export default function NewsCard({ item, variant = "grid" }: { item: NewsItem; variant?: "grid" | "row" }) {
  if (variant === "row") {
    return (
      <Link
        to={`/news/${item.id}`}
        className="group flex gap-4 rounded-lg border border-background-200 bg-background-100 p-3 transition-colors hover:border-primary-400/60"
      >
        <div className="h-24 w-36 flex-shrink-0 overflow-hidden rounded-md md:h-28 md:w-44">
          <img
            src={item.cover}
            alt={`${item.title} - 娱乐资讯配图`}
            title={`${item.title} - 91.con娱乐资讯`}
            className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="flex min-w-0 flex-1 flex-col">
          <div className="mb-2 flex flex-wrap items-center gap-2 text-xs">
            <span className="rounded-sm bg-primary-500/15 px-2 py-0.5 font-medium text-primary-300">
              {getCategoryName(item.category)}
            </span>
            {item.hot && (
              <span className="flex items-center gap-1 rounded-sm bg-accent-500/20 px-2 py-0.5 font-medium text-accent-300">
                <i className="ri-fire-fill"></i>热点
              </span>
            )}
          </div>
          <h3 className="line-clamp-2 font-heading text-base font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-primary-400 md:text-lg">
            {item.title}
          </h3>
          <p className="mt-1.5 line-clamp-2 hidden text-sm text-foreground-600 sm:block">{item.summary}</p>
          <div className="mt-auto flex items-center gap-4 pt-2 text-xs text-foreground-500">
            <span className="flex items-center gap-1">
              <i className="ri-calendar-line"></i>
              {item.date}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-eye-line"></i>
              {formatViews(item.views)}
            </span>
            <span className="hidden items-center gap-1 sm:flex">
              <i className="ri-user-line"></i>
              {item.author}
            </span>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/news/${item.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-100 transition-colors hover:border-primary-400/60"
    >
      <div className="relative h-44 w-full overflow-hidden">
        <img
          src={item.cover}
          alt={`${item.title} - 娱乐资讯配图`}
          title={`${item.title} - 91.con娱乐资讯`}
          className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-3 top-3 rounded-sm bg-primary-500 px-2 py-0.5 text-xs font-medium text-background-50">
          {getCategoryName(item.category)}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-4">
        <h3 className="line-clamp-2 font-heading text-base font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-primary-400">
          {item.title}
        </h3>
        <p className="mt-2 line-clamp-2 text-sm text-foreground-600">{item.summary}</p>
        <div className="mt-auto flex items-center gap-4 pt-4 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line"></i>
            {item.date}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {formatViews(item.views)}
          </span>
        </div>
      </div>
    </Link>
  );
}